"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("react");

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _Autocomplete = require("@mui/material/Autocomplete");

var _Chip = _interopRequireDefault(require("@mui/material/Chip"));

var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _EditDialog = _interopRequireDefault(require("./EditDialog"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Announcer = _interopRequireDefault(require("./Announcer"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Root = (0, _styles.styled)("div")(function () {
  return "\n  color: rgba(0,0,0,.85);\n  font-size: 0.9rem;\n  position: relative;\n  min-width: 18rem;\n  z-index: 1;\n";
});
var InputWrapper = (0, _styles.styled)(_Box.default)(function (_ref) {
  var theme = _ref.theme;
  return "\n  margin-top: ".concat(theme.spacing(2), ";\n  border: 1px solid ").concat(theme.palette.brand.grey.stone, ";\n  background-color: #fff;\n  padding: 1px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  &:hover {\n    border-color: ").concat(theme.palette.primary.main, ";\n  }\n\n  &:focus, :hover, .focus {\n    border-color: ").concat(theme.palette.primary.main, ";\n  }\n\n  &.disabled {\n    background-color: ").concat(theme.palette.brand.grey.lightGrey, "\n  }\n\n  & .MuiTextField-root {\n    background-color: #fff;\n    color: rgba(0,0,0,.85);\n    height: 1.85rem;\n    box-sizing: border-box;\n    width: 0;\n    min-width: 1.85rem;\n    flex-grow: 1;\n    border: 0;\n    margin: 0;\n    outline: 0;\n    & .MuiInput-root{\n      border: unset;\n    }\n  }\n");
});
var Listbox = (0, _styles.styled)("ul")(function (_ref2) {
  var theme = _ref2.theme;
  return "\n  width: 100%;\n  margin: 2px 0 0;\n  padding: 0;\n  position: absolute;\n  list-style: none;\n  background-color: #fff;\n  overflow: auto;\n  max-height: 15rem;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1;\n  & li {\n    padding: 0.31rem 0.75rem;\n    display: grid;\n    grid-template-columns: 5% 90% 5%;\n    align-items: center;\n    font-size: 0.75rem;\n\n    & .content{\n      margin-left: 0.63rem;\n    }\n\n    &.no-record {\n      padding: 0.63rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n  & li[aria-selected='true'] {\n    & svg {\n      color: ".concat(theme.palette.primary.main, "\n    }\n  }\n  & li.").concat(_Autocomplete.autocompleteClasses.focused, " {\n    background-color: ").concat(theme.palette.primary.light, ";\n    cursor: pointer;\n  }\n");
});
var IconContainer = (0, _styles.styled)("span")(function () {
  return "\n  margin-left: 5px;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  padding: 5px;\n  color: rgba(0, 0, 0, 0.54);\n";
});
var StyledButton = (0, _styles.styled)(_material.Button)(function (_ref3) {
  var theme = _ref3.theme;
  return "\n  color: ".concat(theme.palette.primary.main, ";\n  font-weight: 700;\n  font-size: 0.80rem;\n  padding: 5px;\n");
});
var StyledChip = (0, _styles.styled)(_Chip.default)(function (_ref4) {
  var theme = _ref4.theme;
  return "\n  margin: 1px;\n  color: ".concat(theme.palette.brand.grey.charcoal, ";\n  &.extra-count {\n    min-width: ").concat(theme.spacing(5), "\n  }\n  max-width: unset;\n");
});
var StyledIconButton = (0, _styles.styled)(_IconButton.default)(function (_ref5) {
  var theme = _ref5.theme;
  return "\n  &.has-error {\n    color: ".concat(theme.palette.brand.red, ";\n  }\n\n  & .fa-pencil-alt {\n    color: ").concat(theme.palette.primary.main, " !important;\n  }\n");
});
var Overlay = (0, _styles.styled)("div")(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])));

var AutoCompleteAdornment = function AutoCompleteAdornment(_ref6) {
  var popupOpen = _ref6.popupOpen,
      _onClick = _ref6.onClick,
      shouldShowCreate = _ref6.shouldShowCreate,
      onCreate = _ref6.onCreate,
      labels = _ref6.labels,
      _ref6$disabled = _ref6.disabled,
      disabled = _ref6$disabled === void 0 ? false : _ref6$disabled,
      _ref6$error = _ref6.error,
      error = _ref6$error === void 0 ? false : _ref6$error,
      loading = _ref6.loading,
      canManageOptions = _ref6.canManageOptions;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputAdornment.default, {
    position: "end",
    children: [shouldShowCreate && !loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, {
      disabled: !canManageOptions,
      variant: "text",
      onClick: onCreate,
      children: labels.create
    }), shouldShowCreate && loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(IconContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
        size: 15
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "body2",
        sx: {
          marginLeft: 1
        },
        children: labels.creating
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconButton, _objectSpread({
      iconStyle: "fas",
      borderless: true,
      iconName: popupOpen ? "caret-up" : "caret-down",
      "aria-label": popupOpen ? labels.iconCollapse : labels.iconExpand,
      disabled: disabled,
      onClick: function onClick(e) {
        if (!disabled && _onClick) {
          _onClick(e);
        }
      }
    }, error ? {
      className: "has-error"
    } : {}))]
  });
};

var AutocompleteAdvanced = function AutocompleteAdvanced(_ref7) {
  var id = _ref7.id,
      label = _ref7.label,
      onCreate = _ref7.onCreate,
      onEdit = _ref7.onEdit,
      onDelete = _ref7.onDelete,
      options = _ref7.options,
      _ref7$value = _ref7.value,
      value = _ref7$value === void 0 ? [] : _ref7$value,
      _onChange = _ref7.onChange,
      labels = _ref7.labels,
      errorLabels = _ref7.errorLabels,
      _ref7$limitTags = _ref7.limitTags,
      limitTags = _ref7$limitTags === void 0 ? 0 : _ref7$limitTags,
      _ref7$error = _ref7.error,
      error = _ref7$error === void 0 ? false : _ref7$error,
      helperText = _ref7.helperText,
      _ref7$disabled = _ref7.disabled,
      disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
      _ref7$readOnly = _ref7.readOnly,
      readOnly = _ref7$readOnly === void 0 ? false : _ref7$readOnly,
      _ref7$required = _ref7.required,
      required = _ref7$required === void 0 ? false : _ref7$required,
      _ref7$canManageOption = _ref7.canManageOptions,
      canManageOptions = _ref7$canManageOption === void 0 ? false : _ref7$canManageOption,
      _ref7$sx = _ref7.sx,
      sx = _ref7$sx === void 0 ? {} : _ref7$sx,
      className = _ref7.className;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)({
    create: "",
    update: "",
    delete: ""
  }),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      errors = _useState6[0],
      setErrors = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      objectToEdit = _useState8[0],
      setObjectToEdit = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      editOpen = _useState10[0],
      setEditOpen = _useState10[1];

  var _useState11 = (0, _react.useState)({
    create: false,
    update: false
  }),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var selectedOptions = (0, _react.useMemo)(function () {
    return (options || []).filter(function (option) {
      return value.includes(option.value);
    });
  }, [value, options]);

  var _useAutocomplete = (0, _material.useAutocomplete)({
    id: id,
    multiple: true,
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    disableCloseOnSelect: true,
    onInputChange: function onInputChange(_, val) {
      return setInput(val);
    },
    onChange: function onChange(_, val) {
      return _onChange(val);
    },
    value: selectedOptions,
    isOptionEqualToValue: function isOptionEqualToValue(option, val) {
      return option.value === val.value;
    },
    disableClearable: true,
    clearOnBlur: false,
    clearOnEscape: true,
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    inputValue: input
  }),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      groupedOptions = _useAutocomplete.groupedOptions,
      data = _useAutocomplete.value,
      focused = _useAutocomplete.focused,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      popupOpen = _useAutocomplete.popupOpen,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps;

  var limitedRecords = (0, _react.useMemo)(function () {
    if (!limitTags) {
      return {
        result: data,
        extra: 0
      };
    }

    return {
      extra: data.length - limitTags,
      result: (0, _toConsumableArray2.default)(data).slice(0, limitTags)
    };
  }, [data, limitTags]);
  var shouldShowCreate = (0, _react.useMemo)(function () {
    if ((groupedOptions || []).length && input) {
      return groupedOptions.filter(function (optionObj) {
        return optionObj.label.toLowerCase() === input.toLowerCase();
      }).length === 0;
    }

    return !!input && !(groupedOptions || []).length;
  }, [input, groupedOptions]);

  var onCreateOption = function onCreateOption() {
    if (!canManageOptions) {
      return;
    }

    setLoading(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        create: true
      });
    });
    onCreate(input).then(function (response) {
      !(response !== null && response !== void 0 && response.message) && setInput("");
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          create: (response === null || response === void 0 ? void 0 : response.message) || ""
        });
      });
    }).finally(function () {
      setLoading(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          create: false
        });
      });
    });
  };

  var toggleEditPopup = (0, _react.useCallback)(function () {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setObjectToEdit(object);
    setEditOpen(function (prev) {
      return !prev;
    });
  }, [setEditOpen]);

  var onSubmit = function onSubmit(values) {
    if (!canManageOptions) {
      return;
    }

    var validationErrors = {};

    if (!values.label) {
      validationErrors.label = errorLabels.required;
    } else if (options.filter(function (opt) {
      return opt.label.toLowerCase() === values.label.toLowerCase();
    }).length) {
      validationErrors.label = errorLabels.alreadyAvailable;
    }

    if (validationErrors.label) {
      return validationErrors;
    }

    setLoading(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        update: true
      });
    });
    return onEdit(values).then(function (response) {
      !(response !== null && response !== void 0 && response.message) && toggleEditPopup();
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          update: (response === null || response === void 0 ? void 0 : response.message) || ""
        });
      });
      return;
    }).finally(function () {
      setLoading(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          update: false
        });
      });
      return;
    });
  };

  var onDeleteOption = function onDeleteOption(data) {
    if (!canManageOptions) {
      return;
    }

    setLoading(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        update: true
      });
    });
    onDelete(data).then(function (response) {
      if (!(response !== null && response !== void 0 && response.message)) {
        setEditOpen(false);
        setObjectToEdit(null);
      }

      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          delete: (response === null || response === void 0 ? void 0 : response.message) || ""
        });
      });
    }).finally(function () {
      setLoading(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          update: false
        });
      });
      return;
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, _objectSpread(_objectSpread({
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Escape") {
          setOpen(false);
          setInput("");
        }
      }
    }, className ? {
      className: className
    } : {}), {}, {
      children: [loading.create && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Announcer.default, {
        message: loading.create ? labels.creating : ""
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
        children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormLabel, _objectSpread(_objectSpread({}, getInputLabelProps()), {}, {
          required: required,
          error: error,
          disabled: disabled,
          children: label
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(InputWrapper, _objectSpread(_objectSpread({
          ref: setAnchorEl
        }, focused || disabled ? {
          className: (0, _classnames.default)({
            focused: focused
          }, {
            disabled: disabled
          })
        } : {}), {}, {
          sx: sx,
          children: [!focused && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [limitedRecords.result.map(function (option, index) {
              return /*#__PURE__*/(0, _react.createElement)(StyledChip, _objectSpread(_objectSpread({
                variant: "outlined",
                size: "small",
                label: option.label
              }, getTagProps({
                index: index
              })), {}, {
                key: "chips-".concat(option.value)
              }));
            }), limitTags > 0 && data.length > limitTags ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledChip, {
              variant: "outlined",
              size: "small",
              className: "extra-count",
              label: "+".concat(limitedRecords.extra)
            }) : null]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, _objectSpread({
            inputProps: getInputProps(),
            error: error || !!errors.create,
            required: required,
            disabled: disabled,
            readOnly: readOnly
          }, labels.placeholder && !limitedRecords.result.length ? {
            placeholder: labels.placeholder
          } : {})), /*#__PURE__*/(0, _jsxRuntime.jsx)(AutoCompleteAdornment, _objectSpread({
            labels: labels,
            onCreate: onCreateOption,
            shouldShowCreate: shouldShowCreate,
            popupOpen: popupOpen,
            disabled: disabled,
            error: error || !!errors.create,
            loading: loading.create,
            canManageOptions: canManageOptions
          }, getPopupIndicatorProps()))]
        })), !popupOpen && (helperText || !!errors.create) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormHelperText, {
          error: error || !!errors.create,
          children: helperText || errors.create
        })]
      })), groupedOptions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Listbox, _objectSpread(_objectSpread({}, getListboxProps()), {}, {
        children: groupedOptions.map(function (option, index) {
          var optionProps = getOptionProps({
            option: option,
            index: index
          });
          return /*#__PURE__*/(0, _react.createElement)("li", _objectSpread(_objectSpread({}, optionProps), {}, {
            key: "lists-".concat(option.value)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
            checked: !!optionProps["aria-selected"] || false,
            sx: {
              "& .MuiSvgIcon-root": {
                width: "1rem",
                height: "1rem"
              }
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "content",
            children: option.label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconButton, {
            iconStyle: "fas",
            iconName: "pencil-alt",
            borderless: true,
            "aria-label": labels.iconEdit,
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopPropagation();
              toggleEditPopup(option);
            }
          }));
        })
      })), popupOpen && !groupedOptions.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(Listbox, _objectSpread(_objectSpread({}, getListboxProps()), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
          className: "no-record",
          children: [" ", labels.noRecords, " "]
        })
      })), editOpen && objectToEdit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDialog.default, {
        open: editOpen,
        object: objectToEdit,
        onSubmit: onSubmit,
        onDelete: onDeleteOption,
        labels: labels,
        loading: loading.update,
        toggle: toggleEditPopup,
        errors: errors,
        canManageOptions: canManageOptions
      })]
    })), popupOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(Overlay, {
      onClick: function onClick() {
        setInput("");
        setOpen(false);
      }
    })]
  });
};

var _default = AutocompleteAdvanced;
exports.default = _default;